// GENERATED by `pnpm ndrc gen` — do not edit by hand.
import { manifest as ads } from '@ndrc-apps/ads/manifest';
import { manifest as analytics } from '@ndrc-apps/analytics/manifest';
import { manifest as appel } from '@ndrc-apps/appel/manifest';
import { manifest as campaigns } from '@ndrc-apps/campaigns/manifest';
import { manifest as chat } from '@ndrc-apps/chat/manifest';
import { manifest as commerce } from '@ndrc-apps/commerce/manifest';
import { manifest as crm } from '@ndrc-apps/crm/manifest';
import { manifest as inbox } from '@ndrc-apps/inbox/manifest';
import { manifest as mini_sites } from '@ndrc-apps/mini_sites/manifest';
import { manifest as parcours } from '@ndrc-apps/parcours/manifest';
import { manifest as reputation } from '@ndrc-apps/reputation/manifest';
import { manifest as seo_lab } from '@ndrc-apps/seo_lab/manifest';
import { manifest as service_client } from '@ndrc-apps/service_client/manifest';
import { manifest as social_studio } from '@ndrc-apps/social_studio/manifest';
import { manifest as tableur } from '@ndrc-apps/tableur/manifest';
import { manifest as team } from '@ndrc-apps/team/manifest';
import { manifest as website } from '@ndrc-apps/website/manifest';
export const MANIFESTS = { ads, analytics, appel, campaigns, chat, commerce, crm, inbox, mini_sites, parcours, reputation, seo_lab, service_client, social_studio, tableur, team, website } as const;
export type AppId = keyof typeof MANIFESTS;
